import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { BrowseComponent } from 'src/app/folder-views/browse/browse.component';
import { IMenuItem } from 'src/app/navigation/menuInterfaces/menu-item.interface';

import { DemoContentComponent } from '../components/demo-content/demo-content.component';
import { DocumentViewComponent } from 'src/app/document-views/document-view/document-view.component';
import { DocumentAddComponent } from 'src/app/document-add/document-add/document-add.component';
import { ReportsParametersComponent } from 'src/app/reports/reports-parameters/reports-parameters.component';
import { DocumentEditComponent } from 'src/app/document-edit/document-edit/document-edit.component';
import { BusinessOwnerListComponent } from 'src/app/business-owner/business-owner-list/business-owner-list.component';
import { BusinessOwnerEditComponent } from 'src/app/business-owner/business-owner-edit/business-owner-edit.component';
import { FolderSettingsComponent } from 'src/app/folder-views/folder-settings/folder-settings.component';
import { DocumentPrintComponent } from 'src/app/document-views/document-print/document-print.component';
import { BrowseResolverService } from './browse-resolver.service';
import { DocumentchoicesResolverService } from './document-choices.service';
import { AclSearchMainComponent } from 'src/app/acl-search/acl-search-main/acl-search-main.component';
import { UsermanagementComponent } from 'src/app/user-management/usermanagement/usermanagement.component';
import { LegalCounselListComponent } from 'src/app/legal-counsel/legal-counsel-list/legal-counsel-list.component';
import { LegalCounselEditComponent } from 'src/app/legal-counsel/legal-counsel-edit/legal-counsel-edit.component';
import { ManageUserAccessComponent } from 'src/app/user-management/manage-user-access/manage-user-access.component';

@Injectable({
    providedIn: 'root',
})
export class ACLRouteDataService {
    routeData: IMenuItem = {
        id: 'ACL',
        path: 'acl',
        moduleItem: true,
        description: 'Aspen Contracts Library',
        subMenu: [
            {
                id: 'browse',
                path: 'browse',
                description: 'Browse',
                component: BrowseComponent,
                resolve: BrowseResolverService,
            },
            {
                id: 'browse',
                path: 'browse/:folderID',
                bookmarkPath: '../../browse',
                description: 'Browse',
                component: BrowseComponent,
                hideInMenu: true,
                resolve: BrowseResolverService,
            },
            {
                id: 'folderSettings',
                path: 'folderSettings/:folderID',
                bookmarkPath: '../../browse',
                description: 'Folder Settings',
                component: FolderSettingsComponent,
                hideInMenu: true,
            },
            {
                id: 'documentView',
                path: 'DocumentView/:documentID',
                bookmarkPath: '../../browse',
                description: 'Browse',
                component: DocumentViewComponent,
                hideInMenu: true,
                resolve: DocumentchoicesResolverService,
            },
            {
                id: 'documentPrint',
                path: 'DocumentPrint/:documentID',
                bookmarkPath: '../../browse',
                description: 'Browse',
                component: DocumentPrintComponent,
                hideInMenu: true,
                resolve: DocumentchoicesResolverService,
            },
            {
                id: 'documentEdit',
                path: 'documentEdit/:documentID',
                bookmarkPath: '../../browse',
                description: 'Browse',
                component: DocumentEditComponent,
                hideInMenu: true,
                resolve: DocumentchoicesResolverService,
            },
            {
                id: 'documentAdd',
                path: 'DocumentAdd/:folderID',
                bookmarkPath: '../../browse',
                description: 'Browse',
                component: DocumentAddComponent,
                hideInMenu: true,
            },
            {
                id: 'searchMenu',
                path: 'search',
                description: 'Search',
                component: AclSearchMainComponent,
                // subMenu: [
                //     {
                //         id: 'customSearch',
                //         path: 'customSearch',
                //         description: 'Custom Search',
                //         component: AclSearchMainComponent,
                //     },
                //     {
                //         id: 'savedSearch',
                //         path: 'savedSearch',
                //         description: 'Saved Search',
                //     },
                // ],
            },
            {
                id: 'reports',
                path: 'reports',
                description: 'Reports',
                component: DemoContentComponent,
                subMenu: [
                    // {
                    //     id: 'myreports',
                    //     path: 'myreports',
                    //     description: 'My Reports',
                    // },
                    {
                        id: 'activityReports',
                        path: 'activityReports',
                        description: 'Activity Reports',
                        subMenu: [
                            {
                                id: 'Library Activity ReportReport',
                                path: 'LibraryActivityReportReport',
                                description: 'Activity Count by Library Report', // I changed this description
                                component: ReportsParametersComponent,
                                data: {
                                    reportDescription:
                                        'The count of users and documents in each Library for the period specified. Deleted Contracts are excluded from the Total Count of Documents. The data included in the report is up to the synchronisation date.',
                                    reportParameters: [
                                        'LibraryFolder',
                                        'DateFrom',
                                        'DateTo',
                                    ],
                                    unlimitedLibrary: true,
                                    sortOrder: [
                                        'LibraryFolder',
                                        'TerritoryFolder',
                                    ],
                                    subReport: true,
                                },
                            },
                            {
                                id: 'RequestCountByLibrary',
                                path: 'RequestCountByLibrary',
                                description: 'Request Count by Library Report', // I changed this description
                                component: ReportsParametersComponent,
                                data: {
                                    reportDescription:
                                        'The count of requests per Library for the period specified. Deleted Contracts are excluded from the Total Count of Documents. The data included in the report is up to the synchronisation date.',
                                    reportParameters: [
                                        'LibraryFolder',
                                        'DateFrom',
                                        'DateTo',
                                    ],
                                    unlimitedLibrary: true,
                                    sortOrder: [
                                        'LibraryFolder',
                                        'TerritoryFolder',
                                    ],
                                    subReport: true,
                                },
                            },
                            {
                                id: 'Library Alert Activity Report',
                                path: 'LibraryAlertActivityReport',
                                description: 'Library Alert Activity Report', // I changed this description
                                component: ReportsParametersComponent,
                                data: {
                                    reportDescription:
                                        'The count of Alerts due, completed and outstanding in each Library for the prior quarter, current quarter and next quarter. Deleted contracts are excluded. The data included in the report is up to the synchronisation date.',
                                    reportParameters: ['LibraryFolder'],
                                    unlimitedLibrary: true,
                                    sortOrder: ['LibraryFolder', 'AlertPeriod'],
                                    subReport: true,
                                },
                            },
                        ],
                    },
                    {
                        id: 'AlertDueReport',
                        path: 'AlertDueReport',
                        description: 'Alerts Due Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'A report that shows alerts due to be sent during a configured window which have not yet been sent, for a specific library. The alert is based on the Review Deadline Date of the contract. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                                'DateFrom',
                                'DateTo',
                                'NotificationTypeList',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    {
                        id: 'AlertExceptionReport',
                        path: 'AlertExceptionReport',
                        description: 'Alerts Exception Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'A report that shows alerts due to be sent during a configured window which have not yet been sent, for a specific library. The alert is based on the Review Deadline Date of the contract. Deleted contracts are excluded.',
                            reportParameters: ['DateFrom', 'DateTo'],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    {
                        id: 'AlertSentReport',
                        path: 'AlertSentReport',
                        description: 'Alerts Sent Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'A report showing alerts that have been sent for a specified library and time window. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                                'DateFrom',
                                'DateTo',
                                'NotificationTypeList',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    {
                        id: 'BusinessOwnerReport',
                        path: 'BusinessOwnerReport',
                        description: 'Business Owner Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'A report showing all documents associated with a particular business owner. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                                'BusinessOwner',
                            ],
                            sortOrder: [
                                ,
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                            unlimitedLibrary: true,
                        },
                    },
                    {
                        id: 'DateInconsistencyReport',
                        path: 'DateInconsistencyReport',
                        description: 'Date Inconsistency Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'A report displaying a list of contracts where contract end date is dated before contract start date. Deleted contracts are excluded',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    {
                        id: 'DeletedDocumentsReport',
                        path: 'DeletedDocumentsReport',
                        description: 'Deleted Documents Report',
                        component: ReportsParametersComponent,
                        needsRole: ['SuperUser'], // Please note - Super User ONLY
                        data: {
                            reportDescription:
                                'A report showing all documents that have been deleted',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                                'DateFrom',
                                'DateTo',
                                'DeletedReason',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    {
                        id: 'DocumentAuditReport',
                        path: 'DocumentAuditReport',
                        description: 'Document Audit Report', // I changed this description
                        component: ReportsParametersComponent,
                        needsRole: ['SuperUser'], // Please note - Super User ONLY
                        data: {
                            reportDescription:
                                'Audit trail of all activity that has taken place on the selected contracts. ',
                            reportParameters: ['ContractIdentifier'],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'ContractIdentifier',
                                'FieldName',
                            ],
                        },
                    },
                    {
                        id: 'DocumentCountReport',
                        path: 'DocumentCountReport',
                        description:
                            'Document Count by Library and Category Report', // I changed this description
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'Total number of documents displayed by Library and Category. Deleted contracts are excluded.',
                            reportParameters: ['LibraryFolder'],
                            sortOrder: ['LibraryFolder', 'TerritoryFolder'],
                        },
                    },
                    {
                        id: 'DocumentCountLibraryReport',
                        path: 'DocumentCountLibraryReport',
                        description: 'Document Count by Library Report', // I changed this description
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'Total number of documents displayed by Library. Deleted contracts are excluded.',
                            reportParameters: ['LibraryFolder'],
                            sortOrder: ['LibraryFolder', 'TerritoryFolder'],
                        },
                    },
                    {
                        id: 'DuplicateCheckerReport',
                        path: 'DuplicateCheckerReport',
                        description:
                            'Duplicate Documents by Library and Category Report', // I changed this description
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'Duplicate Documents displayed by Library and Category. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                        // needsRole: ['SuperUser'] // Please note - Super User ONLY
                    },

                    // sortOrder: [
                    //             'LibraryFolder',
                    //             'CategoryFolder',
                    //             'documentTitle',
                    //         ],
                    {
                        id: 'IncorrectDocumentFormatReport',
                        path: 'IncorrectDocumentFormatReport',
                        description: 'Incorrect Document Format Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'Report will show any documents not .PDF and .TIFF format, per library and category and will display who loaded it, the date uploaded and for a specified period. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },

                    {
                        id: 'NotTerminatedReport',
                        path: 'NotTerminatedReport',
                        description: 'Index Page Report', // I changed this description
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'A report displaying all documents within the selected Library so that all expired documents not yet terminated can be identified. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    {
                        id: 'LinkedDocumentReport',
                        path: 'LinkedDocumentReport',
                        description: 'Linked Document Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'Report displaying all documents in the Library that has linked documents associated with the contract. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    {
                        id: 'MetaDataReport',
                        path: 'MetaDataReport',
                        description: 'Meta Data Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'A report showing all documents associated with the specified Product, Molecule,Territory or UPI data. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                                'ProductList',
                                'MoleculeList',
                                'TerritoryList',
                                'UPI',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    {
                        id: 'NoAlertRequiredReport',
                        path: 'NoAlertRequiredReport',
                        description: 'No Alert Required Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'A report showing all documents that have the No Alert Required indicator set. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },

                    {
                        id: 'UploadedDatesReport',
                        path: 'UploadedDatesReport',
                        description: 'Uploaded Dates Report (Replicated)',
                        component: ReportsParametersComponent,
                        // needsRole: ['SuperUser'], // Please note - Super User ONLY
                        data: {
                            reportDescription:
                                'A Report displaying all documents uploaded into Libraries detailing the document library name, contract identifier, contract name, category and when uploaded. Deleted contracts are excluded. The data included in the report is up to the synchronisation date.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                            unlimitedLibrary: true,
                        },
                    },
                    {
                        id: 'UploadedDatesRealTimeReport',
                        path: 'UploadedDatesRealTimeReport',
                        description: 'All Documents with Uploaded Dates Report',
                        component: ReportsParametersComponent,
                        // needsRole: ['SuperUser'], // Please note - Super User ONLY
                        data: {
                            reportDescription:
                                'A Report displaying all documents uploaded into Libraries detailing the document library name, contract identifier, contract name, category and when uploaded. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    // {
                    //     id: 'UploadedDatesReportDB',
                    //     path: 'UploadedDatesReportDB',
                    //     description: 'Uploaded Dates Report (DB)',
                    //     component: ReportsParametersComponent,
                    //     needsRole: ['SuperUser'], // Please note - Super User ONLY
                    //     data: {
                    //         reportDescription:
                    //             'A Report displaying all documents uploaded into Libraries detailing the document library name, contract identifier, contract name, category and when uploaded. The data included in the report is up to the synchronisation date. Deleted contracts are excluded.',
                    //         reportParameters: [
                    //             'CategoryFolder',
                    //             'LibraryFolder',
                    //             'DateFrom',
                    //             'DateTo',
                    //         ],
                    //         sortOrder: [
                    //             'LibraryFolder',
                    //             'CategoryFolder',
                    //             'documentTitle',
                    //         ],
                    //     },
                    // },
                    {
                        id: 'userAccessReports',
                        path: 'userAccessReports',
                        description: 'User Access Reports',
                        subMenu: [
                            {
                                id: 'User Access Detail Report',
                                path: 'UserAccessDetailReport',
                                description: 'User Access Detail Report', // I changed this description
                                component: ReportsParametersComponent,
                                data: {
                                    reportDescription:
                                        'A report displaying what access users have to Libraries, Categories and Documents on the system.',
                                    reportParameters: [
                                        'LibraryFolder',
                                        'TerritoryFolder',
                                        'CategoryFolder',
                                        'UserIdAudit',
                                        'TypeOfAccess',
                                        'UserEnabled',
                                    ],
                                    unlimitedLibrary: true,
                                    sortOrder: [
                                        'LoginName',
                                        'LibraryFolder',
                                        'TerritoryFolder',
                                        'CategoryFolder',
                                        'ContractIdentifier',
                                    ],
                                    subReport: true,
                                },
                            },
                            {
                                id: 'User Access Summary Report',
                                path: 'UserAccessSummaryReport',
                                description: 'User Access Summary Report', // I changed this description
                                component: ReportsParametersComponent,
                                data: {
                                    reportDescription:
                                        'A report displaying what access users have to Libraries and Categories on the system. ',
                                    reportParameters: [
                                        'LibraryFolder',
                                        'TerritoryFolder',
                                        'CategoryFolder',
                                        'UserIdAudit',
                                        'TypeOfAccess',
                                        'UserEnabled',
                                    ],
                                    unlimitedLibrary: true,
                                    sortOrder: [
                                        'LoginName',
                                        'LibraryFolder',
                                        'TerritoryFolder',
                                        'CategoryFolder',
                                    ],
                                    subReport: true,
                                },
                            },
                        ],
                    },
                    {
                        id: 'UserAuditReport',
                        path: 'UserAuditReport',
                        description: 'User Audit Report', // I changed this description
                        component: ReportsParametersComponent,
                        needsRole: ['SuperUser'], // Please note - Super User ONLY
                        data: {
                            reportDescription:
                                'Audit trail of all activity that has taken place on the system, by selected user',
                            reportParameters: [
                                'UserIdAudit',
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                                'DateFrom',
                                'DateTo',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'ContractIdentifier',
                            ],
                            unlimitedLibrary: true,
                        },
                    },
                    {
                        id: '30DayDiscrepancyReport',
                        path: '30DayDiscrepancyReport',
                        description: '30 Day Discrepancy Report',
                        component: ReportsParametersComponent,
                        data: {
                            reportDescription:
                                'Documents where Review Deadline Date and Contract End Date Differ by More Than 30 Days. Deleted contracts are excluded.',
                            reportParameters: [
                                'CategoryFolder',
                                'TerritoryFolder',
                                'LibraryFolder',
                            ],
                            sortOrder: [
                                'LibraryFolder',
                                'TerritoryFolder',
                                'CategoryFolder',
                                'documentTitle',
                            ],
                        },
                    },
                    // {
                    //     id: 'SuperUserReport',
                    //     path: 'SuperUserReport',
                    //     description: 'Super User Report',
                    //     needsRole: ['SuperUser'],
                    //     component: DemoContentComponent,
                    // },
                ],
            },
            {
                id: 'administration',
                path: 'administration',
                description: 'Administration',
                component: DemoContentComponent,
                needsRole: ['SuperUser'],
                subMenu: [
                    {
                        id: 'businessOwner',
                        path: 'businessOwner',
                        bookmarkPath: '../businessOwner',
                        description: 'Business Owner Master Data',
                        component: BusinessOwnerListComponent,
                    },
                    {
                        id: 'businessOwner',
                        path: 'businessOwner/:businessOwnerID',
                        bookmarkPath: '../businessOwner',
                        description: 'Business Owner Master Data',
                        hideInMenu: true,
                        component: BusinessOwnerEditComponent,
                    },
                    {
                        id: 'legalCounsel',
                        path: 'legalCounsel',
                        bookmarkPath: '../legalCounsel',
                        description: 'Legal Counsel Master Data',
                        component: LegalCounselListComponent,
                    },
                    {
                        id: 'legalCounsel',
                        path: 'legalCounsel/:legalCounselID',
                        bookmarkPath: '../legalCounsel',
                        description: 'Legal Counsel Master Data',
                        hideInMenu: true,
                        component: LegalCounselEditComponent,
                    },
                ],
            },
            {
                id: 'usermanagement',
                path: 'usermanagement',
                description: 'User Management',
                component: DemoContentComponent,
                needsRole: ['SuperUser'],
                subMenu :[{
                    id: 'userManagementMain',
                    path: 'userManagementMain',
                    description: 'User Management',
                    component: UsermanagementComponent
                },
                {
                    id: 'userManagementAccess',
                    path: 'userManagementAccess',
                    description: 'Manage User Access',
                    component: ManageUserAccessComponent
                }]
            },
        ],
    };

    ofRouteData$ = of(this.routeData);

    constructor(private browseResolverService: BrowseResolverService) {}
}
